import React, { useState, useEffect } from 'react';
import { Row, Col, Form, Upload, message, Divider } from 'antd';
import { Link, useHistory, useParams } from 'react-router-dom';
import { useSelector, useDispatch } from 'react-redux';
import { UploadOutlined, FileOutlined, DownloadOutlined } from '@ant-design/icons';
import Cookies from 'js-cookie';
import _ from "lodash";


import { RecordFormWrapper } from './Style';
import { PageHeader } from '../../../components/page-headers/page-headers';
import { Cards } from '../../../components/cards/frame/cards-frame';
import { Button } from '../../../components/buttons/buttons';
import { Main, BasicFormWrapper } from '../../styled';
import { empleadoReadAction } from '../../../redux/administracion/empleados/actionCreator';

const API_ENDPOINT = process.env.REACT_APP_API_ENDPOINT + '/empleado/fileUpload.php';

const EmpleadoFiles = () => {
  const dispatch = useDispatch();
  const history = useHistory();

  const [action, setAction] = useState('create');
  const registro = useSelector(state => state.EmpleadoReducer.record);
  const isLoading = useSelector(state => state.responseReducer.loading);
  const { id } = useParams();



  useEffect(() => {
    if (id)
      dispatch(empleadoReadAction(id));
    else {
      dispatch(empleadoReadAction());      
    }
  }, [id]);


  const normFile = (e) => {
    console.log('Upload event:', e);

    if (Array.isArray(e)) {
      return e;
    }

    return e && e.fileList;
  };

  const uploadProps = {
    action: API_ENDPOINT,
    accept: ".doc,.docx,.pdf,.png,.jpg,.jpeg",
    showUploadList: false,    
    headers: {
      Authorization: `Bearer ${Cookies.get('dcare_access_token')}`,
    },    
    onChange(info) {
      if (info.file.status !== 'uploading') {
        console.log(info.file, info.fileList);
      }
      if (info.file.status === 'done') {
        message.success(`${info.file.name} archivo subido correctamente`);   
        dispatch(empleadoReadAction(id));     
      } else if (info.file.status === 'error') {
        message.error(`${info.file.name} error al subir el archivo`);
      }
    },
  };

  const showFile = (identificador) => {

    //console.log("registro.documentos: ", registro.documentos);
    let archivo = _.find(registro.documentos, function(o) { return o.identificador === identificador; });
    console.log("archivo? ", archivo);
    let linkToFile = (<><p>Aún no hay archivo</p></>);
    if(archivo) {
      linkToFile = (<p>
        <a href={archivo.url} target='_blank'><DownloadOutlined /> Descargar archivo</a>
        
        </p>)
    }
    return linkToFile
  };

  return (
    <>
      <PageHeader
        buttons={[
          <Button className="btn-add_new" size="default" key="1" type="primary">
            <Link to="/admin/recursos-humanos/listado">Ver todos</Link>
          </Button>,
        ]}
        ghost
        title="EXPEDIENTE DIGITAL"
      />
      <Main>
        <Row gutter={15}>
          <Col xs={24}>

            <RecordFormWrapper>
              <Cards headless>
                <Divider plain>
                  <span style={{textTransform:'uppercase'}}>{registro.nombre} {registro.paterno} {registro.materno}</span>
                   <FileOutlined style={{ fontSize: '16px' }} /></Divider>
                <p><strong>Acta de nacimiento</strong></p>
                <Row gutter={24}>
                <Col lg={6}>
                  {showFile('acta_nacimiento')}
                  </Col> 
                  <Col>
                  <Upload name='acta_nacimiento' data={{empleadoId: id, nombreArchivo: 'acta_nacimiento'}}  {...uploadProps}>
                    
                    <Button icon={<UploadOutlined />}>Subir archivo</Button>
                  </Upload>
                  </Col>                                  
                </Row>

                <p><strong>Constancia de Situación Fiscal</strong></p>
                <Row gutter={24}>
                <Col lg={6}>
                  {showFile('constancia_sat')}
                  </Col> 
                  <Col>
                  <Upload name='constancia_sat' data={{empleadoId: id, nombreArchivo: 'constancia_sat'}}  {...uploadProps}>                    
                    <Button icon={<UploadOutlined />}>Subir archivo</Button>
                  </Upload>
                  </Col>                                  
                </Row>

                <p><strong>Identificación oficial (frente)</strong></p>
                <Row gutter={24}>
                <Col lg={6}>
                  {showFile('identificacion_frente')}
                  </Col> 
                  <Col>
                  <Upload name='identificacion_frente' data={{empleadoId: id, nombreArchivo: 'identificacion_frente'}}  {...uploadProps}>                    
                    <Button icon={<UploadOutlined />}>Subir archivo</Button>
                  </Upload>
                  </Col>                                  
                </Row>

                <p><strong>Identificación oficial (reverso)</strong></p>
                <Row gutter={24}>
                <Col lg={6}>
                  {showFile('identificacion_reverso')}
                  </Col> 
                  <Col>
                  <Upload name='identificacion_reverso' data={{empleadoId: id, nombreArchivo: 'identificacion_reverso'}}  {...uploadProps}>                    
                    <Button icon={<UploadOutlined />}>Subir archivo</Button>
                  </Upload>
                  </Col>                                  
                </Row>

                <p><strong>Solicitud de empleo</strong></p>
                <Row gutter={24}>
                <Col lg={6}>
                  {showFile('solicitud_empleo')}
                  </Col> 
                  <Col>
                  <Upload name='solicitud_empleo' data={{empleadoId: id, nombreArchivo: 'solicitud_empleo'}}  {...uploadProps}>                    
                    <Button icon={<UploadOutlined />}>Subir archivo</Button>
                  </Upload>
                  </Col>                                  
                </Row>

                <p><strong>Constancia de antecedentes no penales</strong></p>
                <Row gutter={24}>
                <Col lg={6}>
                  {showFile('constancia_no_penales')}
                  </Col> 
                  <Col>
                  <Upload name='constancia_no_penales' data={{empleadoId: id, nombreArchivo: 'constancia_no_penales'}}  {...uploadProps}>                    
                    <Button icon={<UploadOutlined />}>Subir archivo</Button>
                  </Upload>
                  </Col>                                  
                </Row>

                <p><strong>Constancia de último grado de estudios</strong></p>
                <Row gutter={24}>
                <Col lg={6}>
                  {showFile('constancia_estudios')}
                  </Col> 
                  <Col>
                  <Upload name='constancia_estudios' data={{empleadoId: id, nombreArchivo: 'constancia_estudios'}}  {...uploadProps}>                    
                    <Button icon={<UploadOutlined />}>Subir archivo</Button>
                  </Upload>
                  </Col>                                  
                </Row>                             
              </Cards>
            </RecordFormWrapper>

          </Col>
        </Row>
      </Main>
    </>
  );
};

export default EmpleadoFiles;
